export default __webpack_public_path__ + "static/workshop-d72829fd7920e426b43815842c679d09.png";